import { GenericInput, getGenericAction } from '@msdyn365-commerce-modules/retail-actions';
import { createObservableDataAction, IAction, IActionInput, IAny, ICreateActionContext, IGeneric } from '@msdyn365-commerce/core';

export function createQuantityInput(result: number): GenericInput<number> {
    return new GenericInput<number>('buyboxQuantity', result, 'Number');
}

const createQuantityInputIternal = (inputData: ICreateActionContext<IGeneric<IAny>>): IActionInput => {
    return createQuantityInput(1);
};

export default createObservableDataAction({
    action: <IAction<number>>getGenericAction,
    input: createQuantityInputIternal
});
